import React, { useEffect, useState } from 'react';
import { FxInput, http, AlertService,formValidator, general, FxSelect } from '../../fx-core';
import './CategoryForm.scss';
import * as _ from 'lodash';
import CameraAltIcon from '@material-ui/icons/CameraAlt';
import dummyImage from "../../../assets/images/dummy.png";
import PhotoCapture from '../../general/PhotoCapture/PhotoCapture';
import { Button, Checkbox, Dialog } from '@material-ui/core';

const ItemForm = (props) => {
  const defaultItem = {
    imagePath: "",
    imageUrl: "",
    categoryCode: "",
    categoryName: "",
    serviceId: -1,
    parentCategoryId: -1,
    isActive: true,
    id: props.categoryId ? props.categoryId : 0,
    communityId: props.communityId
  };

  const [item, setItem] = useState(defaultItem);
  const [services, setServices] = useState([]);
  const [parentCategories, setParentCategories] = useState([]);
  const [errors, setErrors] = useState({});
  const [photoCaptureOpen, setPhotoCaptureOpen] = useState(false);
  const [uploadConfig, setUploadConfig] = useState({});

  const initLookup = () => {
    let inputData = {
      lookups: {
        Services: { default: true },
        ParentCategories: { default: true }
      },
      filters: {
        communityId: item.communityId,
        behaviorCodeFlag: true
      }
    };
    let apiOptions = {
      url: 'options/lookup',
      data: inputData
    };
    http.post(apiOptions).then(res => {
      initLookupCallBack(res);
    })
  }

  const initLookupCallBack = (res) => {
    let result = res.data;
    //let services = result.Services.filter(s => s.code == "ItemWise");
    setServices(result.Services);
    setParentCategories(result.ParentCategories);
    if (props.categoryId > 0) {
      getCategoryById();
    }
  }

  const handleInputChange = (item) => {
    handleItemChange({ [item.name]: item.value });
    item.validations = getInputValidations(item.name);
    const validationResult = formValidator.validate(item);
    const validationData = { [item.name]: validationResult };
    updateErrors(validationData);
  }

  const handleCheckbox = (event) => {
    handleItemChange({ [event.target.name]: event.target.checked });
  }

  const handleItemChange = (data) => {
    setItem(prevState => {
      return { ...prevState, ...data }
    });
  };

  //Validation area starts
  const getValidations = () => {
    const validationMap = {
      categoryCode: ["required"],
      categoryName: ["required", "maxlen"],
      serviceId: ["select"]
    };
    return validationMap;
  }

  const getInputValidations = (name) => {
    let validationMap = getValidations();
    return validationMap[name];
  }

  const bulkValidate = () => {
    let items: any = [];
    let validationMap = getValidations();
    for (var key in validationMap) {
      if (key == "categoryName") {
        let result = { name: key, value: item[key], validations: validationMap[key], param: 25 }
        items.push(result);
      }
      else {
        let result = { name: key, value: item[key], validations: validationMap[key] }
        items.push(result);
      }
    }
    let validationResult = formValidator.bulkValidate(items);
    updateErrors(validationResult.errors);
    return validationResult.isValid;
  }

  const updateErrors = (validationData) => {
    setErrors(prevState => {
      return { ...prevState, ...validationData }
    });
  }

  const hasError = (field, validationMethod) => {
    return (
      errors &&
      errors[field] &&
      errors[field][validationMethod]
    );
  };
  //Validation area ends

  const getCategoryById = () => {
    let apiOptions: any = {
      url: `category/${item.id}`
    };
    http.get(apiOptions).then(res => {
      getCategoryByIdCallBack(res);
    });
  }

  const getCategoryByIdCallBack = (res) => {
    const result = res.data;
    result.imageUrl = general.getImageUrl(result.imagePath);
    setItem(result);
  }

  const saveCategory = () => {
    const isValid = bulkValidate();
    if (isValid) {
      if (item.id > 0) {
        let apiOptions: any = {
          url: `category/update`,
          data: item
        };
        http.put(apiOptions).then(res => {
          saveCategoryCallBack(res.data);
        });
      }
      else {
        let apiOptions: any = {
          url: `category/add`,
          data: item
        };
        http.post(apiOptions).then(res => {
          saveCategoryCallBack(res.data);
        });
      }
    }
  };

  const saveCategoryCallBack = (res) => {
    AlertService.showSuccessMsg();
    if (res > 0) {
      handleClose();
    }
  }

  const openPhotoCapture = () => {
    let photoCaptureConfig = {
      id: item.id,
      cameraConfig: { url: `category/savecameraimage` },
      fileUploadConfig: { url: `category/savefileimage` }
    };
    if (item.communityId > 0) {
      photoCaptureConfig = {
        id: item.id,
        cameraConfig: { url: `category/${item.communityId}/savecameraimage` },
        fileUploadConfig: { url: `category/${item.communityId}/savefileimage` }
      };
    }
    setUploadConfig(photoCaptureConfig);
    setPhotoCaptureOpen(true);
  }

  const onUploadCallBack = (res: any) => {
    setPhotoCaptureOpen(false);
    if (item.id > 0) {
      getCategoryById();
    }
    else {
      let imagePath = res.filePath;
      let imageUrl = general.getImageUrl(imagePath);
      handleItemChange({ imagePath: imagePath, imageUrl: imageUrl });
    }
  }

  const handlePhotoCaptureClose = () => {
    setPhotoCaptureOpen(false);
  }

  const handleClose = () => {
    props.handleCategoryFormClose();
  }

  useEffect(() => {
    initLookup();
  }, []);


  return (
    <div className='categoryform-ui'>
      <div className='row title-font py-1 px-2 drawer-header'>
        <span className="col-11">
          Category Form
        </span>
        <span className="col-1 text-center">
          <i className="fas fa-times-circle font-16 pointer" onClick={handleClose}></i>
        </span>
      </div>

      <div className='p-3 pt-5'>
        <div className='row p-3'>
          <div className="col-2 text-center">
            <div>
              <a className="pointer">
                {!item.imageUrl && <img src={dummyImage} alt="dummy" width={100} height={100}></img>}
                {item.imageUrl && <img src={item.imageUrl} alt="prod" width={100} height={100}></img>}
              </a>
              <div className="text-center camera-align" onClick={openPhotoCapture}>
                <CameraAltIcon className='pointer' />
              </div>
            </div>
          </div>
        </div>
        <div className='col-12 p-3'>
          <FxInput name="categoryCode" variant="outlined" fullWidth size="small" label="Code"
            value={item.categoryCode} onValueChange={handleInputChange} />
          {hasError("categoryCode", "required") &&
            <div className="error">Code is required</div>
          }
        </div>
        <div className='col-12 p-3'>
          <FxInput name="categoryName" variant="outlined" fullWidth size="small" label="Name"
            value={item.categoryName} onValueChange={handleInputChange} />
          {hasError("categoryName", "required") &&
            <div className="error">Name is required</div>
          }
           {
              hasError("categoryName", "maxlen") &&
              <div className="error">Category Name should be less than 25 characters</div>
            }
        </div>

        <div className='col-12 p-3'>
          <FxSelect name="serviceId" variant="outlined" label="Service"
            options={services}
            selectedValue={item.serviceId}
            valueField="id"
            displayField="text"
            size="small"
            fullWidth
            onValueChange={handleInputChange} />
          {
            hasError("serviceId", "select") &&
            <div className="error">Service is required</div>
          }
        </div>

        <div className='col-12 p-3'>
          <FxSelect name="parentCategoryId" variant="outlined" label="Parent Category"
            options={parentCategories}
            selectedValue={item.parentCategoryId}
            valueField="id"
            displayField="text"
            size="small"
            fullWidth
            onValueChange={handleInputChange} />
        </div>        

        <div className='col-12 p-3'>
          <Checkbox name="isActive" color="primary" checked={item.isActive} value={item.isActive} onChange={handleCheckbox} />
          Active
        </div>
      </div>
      <div className='px-4 py-2 drawer-footer'>
        <Button color="primary" variant="contained" fullWidth className='btn-style' onClick={saveCategory}><b>Save</b></Button>
      </div>
      <Dialog
        open={photoCaptureOpen}
        onClose={handlePhotoCaptureClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description">
        <PhotoCapture uploadConfig={uploadConfig} onUploadCallBack={onUploadCallBack} handlePhotoCaptureClose={handlePhotoCaptureClose} />
      </Dialog>
    </div>
  );
}
export default ItemForm;
